import { NavMarker } from 'react-rhumb';
import enviro from 'enviro';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Flow } from 'signup-constants/Flow';
import ViralLink from 'viral-links-lib/viral-link/ViralLink';
import { getLiveChatParams } from '../utils/urls';
import { getFullUrl } from 'hubspot-url-utils';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
export default function LiveChat() {
  const queryParams = getLiveChatParams();
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "LIVE_CHAT_LINK_LOADED",
    children: /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "row",
      children: /*#__PURE__*/_jsx(ViralLink, {
        use: "primary",
        intermediatePage: `${getFullUrl('app')}/livechat-unboxing`,
        portalId: queryParams.viralSourcePortalId ? parseInt(queryParams.viralSourcePortalId, 10) : undefined,
        environment: enviro.getShort(),
        flow: Flow.Crm,
        viralLinkType: "livechat",
        additionalParams: queryParams,
        ariaLabel: I18n.text('app.viralLinks.liveChat.ariaLabel'),
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "app.viralLinks.liveChat.linkCta"
        })
      })
    })
  });
}